// extracted by mini-css-extract-plugin
module.exports = {"icon-add":"text-box-expandable_icon-add__6bvjA","icon-remove":"text-box-expandable_icon-remove__4Og5g"};